import { instance } from "api/apiBase";
import type {
  CreateStagePayload,
  DeleteStagePayload,
  Stage,
  StageDeleteConflictResponse,
  StageKind,
  UpdateStagePayload
} from "./types/stage";

export const stagesQueryKey = (kind: StageKind) => ["stages", kind];

type StageListResponse = {
  stages: Stage[];
};

type StageResponse = {
  stage: Stage;
};

export const fetchStages = async (kind: StageKind): Promise<Stage[]> => {
  const response = await instance.get<StageListResponse>("/portal/v1/stages", {
    params: { kind }
  });

  return response.data.stages;
};

export const createStage = async (
  payload: CreateStagePayload
): Promise<Stage> => {
  const response = await instance.post<StageResponse>(
    "/portal/v1/stages",
    payload
  );

  return response.data.stage;
};

export const updateStage = async (
  id: number,
  payload: UpdateStagePayload
): Promise<Stage> => {
  const response = await instance.patch<StageResponse>(
    `/portal/v1/stages/${id}`,
    payload
  );

  return response.data.stage;
};

export const deleteStage = async (
  id: number,
  payload?: DeleteStagePayload
): Promise<Stage> => {
  const response = payload
    ? await instance.post<StageResponse>(
        `/portal/v1/stages/${id}/delete`,
        payload
      )
    : await instance.post<StageResponse>(`/portal/v1/stages/${id}/delete`);

  return response.data.stage;
};

export const checkStageDeleteConflict = async (
  id: number
): Promise<StageDeleteConflictResponse> => {
  const response = await instance.get<StageDeleteConflictResponse>(
    `/portal/v1/stages/${id}/check_delete_conflict`
  );

  return response.data;
};
